module.exports = __webpack_public_path__ + "55a72598cd6c3be62992a00de6836e9d.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/share-slogan-2.png
// module id = 502
// module chunks = 0